import { makeActionCreator } from '../../../../utilities'
import { MotorVehicleIncidentConstants } from './motorVehicleIncident.constants'

export const setNumberOfVehiclesInvolved = makeActionCreator(
  MotorVehicleIncidentConstants.SET_NUMBER_OF_VEHICLES_INVOLVED,
  'numberOfVehiclesInvolved'
)
export const setAirbagDeployed = makeActionCreator(MotorVehicleIncidentConstants.SET_AIRBAG_DEPLOYED, 'airbagDeployed')
export const setVehicleImpactSite = makeActionCreator(
  MotorVehicleIncidentConstants.SET_VEHICLE_IMPACT_SITE,
  'vehicleImpactSite'
)
export const setLocationOfPatientInVehicle = makeActionCreator(
  MotorVehicleIncidentConstants.SET_LOCATION_OF_PATIENT_IN_VEHICLE,
  'locationOfPatientInVehicle'
)
export const setExtricationRequired = makeActionCreator(
  MotorVehicleIncidentConstants.SET_EXTRICATION_REQUIRED,
  'extricationRequired'
)
export const setMotorVehicleIncident = makeActionCreator(
  MotorVehicleIncidentConstants.SET_MOTOR_VEHICLE_INCIDENT,
  'motorVehicleIncidentData'
)
export const resetMotorVehicleIncident = makeActionCreator(MotorVehicleIncidentConstants.RESET_MOTOR_VEHICLE_INCIDENT)
export const clearMotorVehicleIncident = makeActionCreator(MotorVehicleIncidentConstants.CLEAR_MOTOR_VEHICLE_INCIDENT)
export const saveMotorVehicleIncident = makeActionCreator(MotorVehicleIncidentConstants.SAVE_MOTOR_VEHICLE_INCIDENT)
